import React from "react";
import { Hotel, Building, Utensils, Sparkles, ChevronRight, Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const industries = [{
  title: "Hotelový textil",
  icon: Hotel,
  description: "Prémiové praní a žehlení pro hotely, penziony i butikové ubytování.",
  benefits: ["Aby vaše prádlo bylo vizitkou vaší dokonalosti", "Expresní noční doručení pro ranní směny", "Šetrné praní prodlužující životnost textilu"],
  link: "#"
}, {
  title: "Apartmány a Airbnb",
  icon: Building,
  description: "Kompletní servis pro správce nemovitostí a hostitele.",
  benefits: ["Pravidelné noční svozy bez nutnosti přítomnosti uklízečky", "Dokonalá čistota ložního prádla", "Garance doručení před check-inem hostů"],
  link: "#"
}, {
  title: "Restaurace a catering",
  icon: Utensils,
  description: "Profesionální čištění stolního prádla a uniforem.",
  benefits: ["Účinné odstranění odolných skvrn a mastnoty", "Zářivě čisté ubrusy a ubrousky", "Dokonalá čistota, kterou vaši hosté ucítí\n\n"],
  link: "#"
}, {
  title: "Wellness a Spa",
  icon: Sparkles,
  description: "Jemná péče o ručníky, župany a prostěradla.",
  benefits: ["Maximální měkkost a nadýchanost froté", "Speciální technologie pro odstranění olejů", "Certifikovaná dezinfekce pro zdravotní nezávadnost"],
  link: "#"
}];
export default function IndustrySolutions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="řešení-pro-vaše-odvětví" ref={ref} className={cn("py-16 md:py-24 bg-muted/30 transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-4">
            Řešení na míru vašemu podnikání
          </h2>
          <p className="text-lg text-muted-foreground">S-clean prádelna Vršovice Praha poskytuje specializované služby pro náročné provozy. Díky více než 10 letům zkušeností rozumíme specifickým potřebám každého odvětví.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {industries.map((item, i) => <Card key={i} data-index={i} className="bg-background border-border/50 shadow-sm hover:shadow-md transition-all duration-300 group h-full flex flex-col">
              <CardHeader className="pb-4">
                <div className="mb-4 inline-flex items-center justify-center size-12 rounded-lg bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                  <item.icon className="size-6" />
                </div>
                <CardTitle className="text-xl md:text-2xl text-foreground">
                  {item.title}
                </CardTitle>
                <CardDescription className="text-base mt-2">
                  {item.description}
                </CardDescription>
              </CardHeader>
              
              <CardContent className="flex-grow">
                <ul className="space-y-3">
                  {item.benefits.map((benefit, j) => <li key={j} data-index={j} className="flex items-start gap-3 text-muted-foreground">
                      <Check className="size-5 text-primary shrink-0 mt-0.5" />
                      <span className="text-sm md:text-base">{benefit}</span>
                    </li>)}
                </ul>
              </CardContent>

              <CardFooter className="pt-4">
                <Link to={item.link} className="inline-flex items-center text-sm font-medium text-primary hover:text-primary/80 transition-colors group/link">
                  Zjistit více
                  <ChevronRight className="ml-1 size-4 transition-transform group-hover/link:translate-x-1" />
                </Link>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}